import { rest } from 'msw'
import mockFiatCurrencies from '../../../__mocks__/fiatCurrencies.json'
import { Currency } from 'types/types'

const getFiatCurrencies = rest.get<Currency[]>(
  `${API_URL}/api/currency/fiat`,
  async (req, res, ctx) => {
    return res(ctx.json(mockFiatCurrencies))
  }
)

export default [getFiatCurrencies]
